import React from 'react';

import { StyleSheet, Text, View } from '@react-pdf/renderer';
import { Style } from '@react-pdf/types';
import { getColorObjectStyleByRecord } from 'PDF/helpers/documentStyle';

interface IHeaderProps {
  dates: (string | number)[];
  shouldAlignStart?: boolean;
  hasLeftHeading?: boolean;
  isRatiosTable?: boolean;
  firstColumnWidth?: number;
}

const colorIndexes = {
  green: 7,
  blue: 0,
  red: 0,
  blueGreen: 6,
  blueRed: 0,
  blueYellow: 7,
};

export const Header: React.FC<IHeaderProps> = ({
  dates,
  shouldAlignStart = false,
  hasLeftHeading = false,
  isRatiosTable = false,
  firstColumnWidth,
}) => {
  const renderTextWithNewLines = (text: string | number) => {
    return String(text)
      .split('/n')
      .map((line, index) => <Text key={index}>{line}</Text>);
  };

  return (
    <View
      style={[
        styles.header,
        getColorObjectStyleByRecord(colorIndexes, 'backgroundColor') as Style,
        { padding: hasLeftHeading ? '3px 5px 3px 3px' : '3px 5px 3px 160px' },
      ]}
      wrap={false}
    >
      {dates.map((date, index) => (
        <View
          key={index}
          style={[
            styles.ceil,
            { alignItems: shouldAlignStart ? 'flex-start' : 'center' },
            hasLeftHeading && index === 0 ? { justifyContent: 'flex-start' } : { justifyContent: 'flex-end' },
            isRatiosTable && index === 0 ? { minWidth: '130px', maxWidth: '130px' } : { width: '100%' },
            ...(firstColumnWidth && index === 0 ? [{ minWidth: firstColumnWidth, maxWidth: firstColumnWidth }] : []),
            isRatiosTable && index === 1 ? { minWidth: '81px', maxWidth: '81px' } : { width: '100%' },
            ...(firstColumnWidth && index === 1 ? [{ minWidth: 'auto', maxWidth: 'auto' }] : []),
          ]}
        >
          <Text style={styles.text}>{renderTextWithNewLines(date)}</Text>
        </View>
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  header: {
    display: 'flex',
    flexDirection: 'row',
    minHeight: '17px',
  },
  ceil: {
    fontFamily: 'Noto',
    fontWeight: 600,
    fontSize: '9px',
    color: '#fff',
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
  },
  text: {
    textAlign: 'right',
  },
});
